import { Bell } from 'lucide-react'
import React, { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'
import AutoScrollEvents from '../components/AutoScrollEvents'
import HebrewDate from '../components/HebrewDate'
import { FamilyContext } from '../Context/FamilyHeadContext'
import UnifiedSearch from './Search/UnifiedSearch'
import WelcomeText from "../data/WelcomeText";
import {useTranslation} from "react-i18next";

const HomePage = () => {
  const { currentAnnouncement } = useContext(FamilyContext)
  const { currentFamilyHead } = useContext(FamilyContext)
  const { pathPrefix } = useContext(FamilyContext)
  const { t } = useTranslation()

  useEffect(() => {
    console.log('rendered')
  }, [])

  const convertLinksInText = (text) => {
    return text.replace(/\[\[(.*?)\|(.*?)\]\]/g, (match, url, displayText) => (
        `<a href="${url}" target="_blank" rel="noopener noreferrer" 
        class="text-[#937c5d] hover:text-[#c9a66c] underline">${displayText}</a>`
    ));
  };

  return (
    <div className="min-h-screen py-16 px-4 bg-[#f8f5f1]">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8 rtl">
        {/* Left Column */}
        <div className="space-y-8">
          {currentAnnouncement?.length > 0 && (
              <div className="bg-[#937c5d]/10 rounded-lg p-4 text-center">
                <div className="text-[#4a3f30] font-heebo font-medium flex gap-1">
                  <Bell className="w-5 h-5 text-amber-500" />
                  <span className="font-bold">{t('home.managementMassage')}</span>
                  <div
                      dangerouslySetInnerHTML={{
                        __html: convertLinksInText(currentAnnouncement)
                      }}
                  />
                </div>
              </div>
          )}
          <div className="bg-white rounded-2xl p-6 shadow-[0_4px_20px_rgba(201,166,108,0.08)]">
            <div className="text-[#4a3f30] text-lg leading-relaxed font-heebo">
              <WelcomeText/>
              <Link to={`${pathPrefix}familyTree?rootId=${currentFamilyHead.gedId}`} className="text-[#937c5d]">
                {t('home.treeView')}
              </Link>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-[0_4px_20px_rgba(201,166,108,0.08)]">
            <h2 className="text-2xl font-heebo font-bold text-[#937c5d] mb-4">
            {t('home.searchTitle')}
            </h2>
            <UnifiedSearch variant="standalone"/>
          </div>
        </div>

        {/* Right Column */}
        <div className="bg-white rounded-2xl p-6 shadow-[0_4px_20px_rgba(201,166,108,0.08)]">
          <div className="mb-8">
            <h3
                className="text-2xl font-heebo font-bold text-[#937c5d] relative pb-3
                            after:content-[''] after:absolute after:-bottom-1 after:left-0 after:right-0
                            after:h-[2px] after:bg-gradient-to-r after:from-[#937c5d] after:to-[#c9a66c]"
            >
              <div className="flex items-center gap-2">
                <span>{t('home.todayDate')}</span>
                <HebrewDate/>
              </div>

            </h3>
          </div>
          <AutoScrollEvents/>
        </div>
      </div>
    </div>
  )
}

export default HomePage
